import React from "react";
import "../../../styles/customize-components/mod-header-with-toggle.css";

const ModHeaderWithToggle = ({
  title,
  isToggleOn,
  onToggleChange,
  onClose,
  isReload,
  onReload,
}) => {
  return (
    <div className="mwt-container">
      <h2 className="mwt-title-head">
        {title}

        <label className="mwt-toggle-switch">
          <input
            type="checkbox"
            checked={isToggleOn}
            onChange={onToggleChange}
          />
          <span className="mwt-toggle-slider"></span>
        </label>
        
        {isReload && (
          <button className="mwt-reload-btn" type="button" onClick={onReload}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-arrow-clockwise"
              viewBox="0 0 16 16">
              <path
                fillRule="evenodd"
                d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
              />
              <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
            </svg>
          </button>
        )}
      </h2>

      <button className="mwt-close-btn" onClick={onClose}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-x-lg"
          viewBox="0 0 16 16">
          <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
        </svg>
      </button>
    </div>
  );
};

export default ModHeaderWithToggle;
